import { Dispatch, SetStateAction } from 'react'
import Modal from 'components/Modal/Modal'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import Input from 'components/Input/Input'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useServiceAreas } from 'providers/ServiceAreasProvider'
import { usePatchDeliveryAreaGroup } from 'hooks/useServiceAreas'
import { useParams } from 'react-router-dom'
import { useAlert } from 'providers/AlertProvider'

export const ServiceAreaSettingsModal = ({
  modal,
  setModal,
}: {
  modal: { right: boolean }
  setModal: Dispatch<
    SetStateAction<{
      right: boolean
    }>
  >
}) => {
  const { selectedDeliveryArea, setSelectedDeliveryArea } = useServiceAreas()
  const { t } = useTranslation()
  const theme = useTheme()
  const { placeId } = useParams()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { setAlert } = useAlert()

  const initialValuesForSelectedArea = {
    name: selectedDeliveryArea.name,
  }

  const { mutateAsync, isLoading: isLoadingPatchRequest } =
    usePatchDeliveryAreaGroup(
      placeId as string,
      String(selectedDeliveryArea.id)
    )

  const handleCloseSelectedAreaModal = () => {
    setModal({ right: false })
  }

  const handleChangeForSelectedArea = async (values: { name: string }) => {
    const modifiedValues = {
      name: values.name,
    }
    await mutateAsync(modifiedValues, {
      onSuccess: () => {
        setSelectedDeliveryArea({
          id: selectedDeliveryArea.id,
          name: modifiedValues.name,
        })
        setAlert(t('saved'), 'success', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        })
        setModal({ right: false })
      },
      onError: () => {
        setAlert(t('failureMessage'), 'failure', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'right',
        })
      },
    })
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesForSelectedArea}
      onSubmit={async (values) => handleChangeForSelectedArea(values)}>
      {({ isValid, dirty, submitForm }) => (
        <Modal
          isLoadingRequest={isLoadingPatchRequest}
          buttonIsDisabled={!isValid || !dirty}
          onButtonClick={submitForm}
          showButton
          buttonText={t('save')}
          setModal={handleCloseSelectedAreaModal}
          modal={modal}
          title={t('settings')}>
          <Form>
            <Box
              sx={{ display: isMobile ? 'block' : 'flex' }}
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              height='calc(100vh - 180px)'>
              <Input
                errorMessage=''
                label={t('name')}
                name='name'
                type='text'
                variant='filled'
                fullWidth
                width='450px'
              />
            </Box>
          </Form>
        </Modal>
      )}
    </Formik>
  )
}
